class Util {

    static GenFlash(msg, index) {
        const f = document.createDocumentFragment();
        const d = document.createElement('DIV');
        if(index === 2) {
            d.classList.add('alert', 'alert-danger', 'alert-dismissible', 'fade', 'show');
        } else if(index === 1) {
            d.classList.add('alert', 'alert-warning', 'alert-dismissible', 'fade', 'show');
        } else {
            d.classList.add('alert', 'alert-success', 'alert-dismissible', 'fade', 'show');
        }
        d.setAttribute('role', 'alert');
        f.appendChild(d);
        const b = document.createElement('BUTTON');
        b.type = 'button';
        b.classList.add('close');
        b.dataset.dismiss = 'alert';
        b.setAttribute('aria-label', 'Close');
        d.appendChild(b);
        const s = document.createElement('SPAN');
        s.setAttribute('aria-hidden', 'true');
        s.textContent = '×';
        b.appendChild(s);
        d.insertAdjacentHTML('beforeend', msg);
        return f;
    }


    static GenFlashSuccess(msg) {
        return Util.GenFlash(msg, 0);
    }


    static GenFlashWarning(msg) {
        return Util.GenFlash(msg, 1);
    }


    static GenFlashDanger(msg) {
        return Util.GenFlash(msg, 2);
    }


    static GenDomValidateError(inValidElm, msg) {
        const div = inValidElm.parentElement;
        const label = inValidElm.previousElementSibling;
        if(div == null && label == null) {
            return;
        }
        inValidElm.classList.add('is-invalid');
        const html = '<div class="invalid-feedback">' + label.textContent + msg + '</div>';
        div.insertAdjacentHTML('beforeend', html);
    }


    static GenDomValidateErrorWithColumnName(inValidElm, column_name, msg) {
        const div = inValidElm.parentElement;
        if(div == null) {
            return;
        }
        inValidElm.classList.add('is-invalid');
        const html = '<div class="invalid-feedback">' + column_name + msg + '</div>';
        div.insertAdjacentHTML('beforeend', html);
    }


    static DelDomValidateError() {
        const invalidFeedbacks = document.getElementsByClassName('invalid-feedback');
        while(invalidFeedbacks.length > 0) {
            const o = invalidFeedbacks[0];
            o.previousElementSibling.classList.remove('is-invalid');
            o.remove();
        }
    }


    static DelDomValidateErrorOnlyInvalidElm(invalidElm) {
        invalidElm.classList.remove('is-invalid');
    }


    static GenPromise(url, method, jsonData, signInUrl, headers = null, timeoutSec = 60) {
        const result = {
            'success': null,
            'error': null,
            'statusCode': null,
        };
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.timeout = timeoutSec*1000;
            xhr.open(method, url);
            xhr.setRequestHeader('Content-Type', 'application/json');
            if(headers != null) {
                for(const key of Object.keys(headers)) {
                    xhr.setRequestHeader(key, headers[key]);
                }
            }
            xhr.onload = () => {
                result.statusCode = xhr.status;
                if(xhr.status === 200) {
                    if(xhr.responseURL === signInUrl) {
                        location.href = xhr.responseURL;
                        return;
                    }
                    result.success = xhr.response;
                    resolve(result);
                } else if(xhr.status === 302 || xhr.status === 303 || xhr.status === 307) {
                    if(xhr.getResponseHeader('Location') != null) {
                        location.href = xhr.getResponseHeader('Location');
                        return;
                    } else {
                        location.reload();
                        return;
                    }
                } else if(xhr.status === 422) {
                    location.reload();
                    return;
                } else {
                    if(xhr.responseText != null && xhr.responseText !== '') {
                        result.error = xhr.responseText
                    } else {
                        result.error = xhr.statusText;
                    }
                    reject(result);
                }
            }
            xhr.onerror = () => {
                result.statusCode = xhr.status;
                result.error = xhr.statusText;
                reject(result);
            }
            xhr.send(JSON.stringify(jsonData));
        });
    }


    static EscapeHtml(str) {
        return str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
    }

}
export { Util }
